import * as React from "react";

function SvgFlame(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 30 40"
      {...props}
    >
      <path
        d="M12.01 1c7.814 5.218 28.616 29.74 8.417 38 3.29-3.394 4.578-6.313 3.678-10.817-1.232-4.808-4.134-8.403-7.524-11.643.394 5.676-.535 9.88-2.892 12.496-.399-2.249-1.44-4.058-3.185-5.396-1.637 3.549-3.422 7.225-3.18 9.087C7.421 35.44 9.87 36.9 12.011 39c-3.947-.962-8.139-2.002-10.1-6.609-4.665-10.957 10.1-23.13 10.1-31.391z"
        stroke="currentColor"
        strokeWidth={1.8}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgFlame;
